export const UI = {
  en: {
    nav_about: "About", nav_skills: "Skills", nav_experience: "Experience",
    nav_projects: "Projects", nav_education: "Education", nav_contact: "Contact",
    nav_resume: "Resume",
    hero_availability: "Available for new opportunities",
    hero_role1: "FULL STACK JAVA", hero_role2: "DEVELOPER",
    hero_sub: "8+ years architecting high-concurrency enterprise systems across telecom, banking, healthcare, IoT and AI — from legacy modernization to cloud-native platforms on AWS & Kubernetes.",
    hero_cta_projects: "Explore 15 Projects",
    hero_cta_resume: "Download Resume",
    hero_since: "Since 2016",
    hero_role_tag: "Enterprise Systems Engineer",
    hero_projects_label: "Projects",
    hero_scroll: "Scroll to about section",
    about_title: "About",
    about_sub: "Senior engineer, enterprise craftsman.",
    about_summary: "Results-driven Full Stack Java Developer with 8+ years of experience designing, developing, and modernizing enterprise software across telecommunications, healthcare, IoT, AI, blockchain, and cloud environments. Proven ability to modernize legacy systems, build scalable cloud-native applications, automate deployments, and deliver reliable software in Agile environments.",
    about_loc: "U.S. Citizen · Open to relocation & remote",
    about_certline: "Cisco, Microsoft & CompTIA certified — networking, cloud & security background",
    about_langline: "Fluent in Korean and English — 7 years delivering in Seoul's enterprise market",
    stat_years: "Years Experience", stat_projects: "Enterprise Projects",
    stat_companies: "Companies", stat_industries: "Industries",
    skills_title: "Skills Matrix",
    skills_sub: "Full-stack depth, infrastructure breadth.",
    skill_cat_0: "Backend", skill_cat_1: "Frontend", skill_cat_2: "Databases",
    skill_cat_3: "DevOps & Cloud", skill_cat_4: "Data Engineering", skill_cat_5: "Infrastructure",
    exp_title: "Experience",
    exp_sub: "Seven years of enterprise delivery across Seoul's most demanding engineering organizations.",
    type_contract: "Contract", type_fixedterm: "Fixed-term Freelance", type_startup: "Startup Contract",
    projects_title: "Selected Work",
    projects_sub: "Fifteen production systems across national healthcare, telecom, blockchain, banking, smart cities and applied AI. Click any project for the full breakdown.",
    case_study: "Case Study",
    live_site: "Live Site",
    read_case: "Read Full Case Study",
    visit_live: "Visit Live Website",
    tech_stack: "Tech Stack",
    edu_title: "Education & Credentials",
    edu_sub: "Click any certification to view its official certificate or transcript.",
    earned: "Earned", expired: "Expired",
    status_active: "Active", status_inactive: "Inactive", status_expired: "Expired",
    open_full: "Open Full",
    contact_title: "Let's Build Something",
    contact_sub: "Hiring for a senior backend or full-stack role? Reach out directly — click my email to open your mail app, or copy any of my details with one click.",
    email_hint: "Opens your email app",
    copy_hint: "Click to copy",
    copied: "Copied to clipboard",
    footer_role: "Full Stack Java Developer",
    detail_challenge: "The Challenge", detail_approach: "The Approach", detail_outcome: "The Outcome",
    detail_all: "All Projects", detail_notfound: "Project not found.",
    detail_back: "Back to portfolio", prev: "Prev", next: "Next",
  },
  ko: {
    nav_about: "소개", nav_skills: "기술", nav_experience: "경력",
    nav_projects: "프로젝트", nav_education: "학력", nav_contact: "연락처",
    nav_resume: "이력서",
    hero_availability: "새로운 기회를 찾고 있습니다",
    hero_role1: "풀스택 자바", hero_role2: "개발자",
    hero_sub: "통신, 금융, 헬스케어, IoT, AI 분야에서 8년 이상 고성능 엔터프라이즈 시스템을 설계·구축해온 개발자입니다 — 레거시 현대화부터 AWS & Kubernetes 기반 클라우드 네이티브 플랫폼까지.",
    hero_cta_projects: "프로젝트 15개 보기",
    hero_cta_resume: "이력서 다운로드",
    hero_since: "2016년부터",
    hero_role_tag: "엔터프라이즈 시스템 엔지니어",
    hero_projects_label: "프로젝트",
    hero_scroll: "소개 섹션으로 스크롤",
    about_title: "소개",
    about_sub: "시니어 엔지니어, 엔터프라이즈 장인.",
    about_summary: "통신, 헬스케어, IoT, AI, 블록체인, 클라우드 환경 전반에서 엔터프라이즈 소프트웨어를 설계·개발·현대화한 8년 이상의 경력을 보유한 성과 중심의 풀스택 자바 개발자입니다. 레거시 시스템 현대화, 확장 가능한 클라우드 네이티브 애플리케이션 구축, 배포 자동화, 애자일 환경에서의 안정적인 소프트웨어 제공 역량이 입증되었습니다.",
    about_loc: "미국 시민 · 이주 및 원격 근무 가능",
    about_certline: "Cisco, Microsoft, CompTIA 자격증 보유 — 네트워크, 클라우드, 보안 전문성",
    about_langline: "한국어·영어 능통 — 서울 엔터프라이즈 시장에서 7년간 프로젝트 수행",
    stat_years: "년 경력", stat_projects: "엔터프라이즈 프로젝트",
    stat_companies: "근무 기업", stat_industries: "산업 분야",
    skills_title: "기술 매트릭스",
    skills_sub: "풀스택의 깊이, 인프라의 넓이.",
    skill_cat_0: "백엔드", skill_cat_1: "프론트엔드", skill_cat_2: "데이터베이스",
    skill_cat_3: "DevOps & 클라우드", skill_cat_4: "데이터 엔지니어링", skill_cat_5: "인프라",
    exp_title: "경력",
    exp_sub: "서울의 가장 까다로운 엔지니어링 조직에서 7년간 엔터프라이즈 프로젝트를 수행했습니다.",
    type_contract: "계약직", type_fixedterm: "기간제 프리랜스", type_startup: "스타트업 계약",
    projects_title: "주요 프로젝트",
    projects_sub: "국가 헬스케어, 통신, 블록체인, 금융, 스마트시티, 응용 AI 분야의 15개 운영 시스템. 프로젝트를 클릭하면 전체 내용을 볼 수 있습니다.",
    case_study: "사례 연구",
    live_site: "라이브 사이트",
    read_case: "전체 사례 연구 보기",
    visit_live: "웹사이트 방문",
    tech_stack: "기술 스택",
    edu_title: "학력 및 자격증",
    edu_sub: "자격증을 클릭하면 공식 인증서 또는 성적표를 볼 수 있습니다.",
    earned: "취득", expired: "만료",
    status_active: "유효", status_inactive: "비활성", status_expired: "만료",
    open_full: "크게 보기",
    contact_title: "함께 만들어 봅시다",
    contact_sub: "시니어 백엔드 또는 풀스택 포지션을 채용 중이신가요? 직접 연락해 주세요 — 이메일을 클릭하면 메일 앱이 열리고, 나머지 정보는 한 번의 클릭으로 복사됩니다.",
    email_hint: "메일 앱이 열립니다",
    copy_hint: "클릭하여 복사",
    copied: "클립보드에 복사됨",
    footer_role: "풀스택 자바 개발자",
    detail_challenge: "도전 과제", detail_approach: "접근 방법", detail_outcome: "성과",
    detail_all: "전체 프로젝트", detail_notfound: "프로젝트를 찾을 수 없습니다.",
    detail_back: "포트폴리오로 돌아가기", prev: "이전", next: "다음",
  },
  zh: {
    nav_about: "关于", nav_skills: "技能", nav_experience: "经历",
    nav_projects: "项目", nav_education: "教育", nav_contact: "联系",
    nav_resume: "简历",
    hero_availability: "正在寻找新的机会",
    hero_role1: "全栈 JAVA", hero_role2: "开发工程师",
    hero_sub: "拥有 8 年以上在电信、银行、医疗、物联网和人工智能领域构建高并发企业级系统的经验 — 从遗留系统现代化到基于 AWS 与 Kubernetes 的云原生平台。",
    hero_cta_projects: "查看 15 个项目",
    hero_cta_resume: "下载简历",
    hero_since: "自 2016 年",
    hero_role_tag: "企业级系统工程师",
    hero_projects_label: "项目",
    hero_scroll: "滚动至关于部分",
    about_title: "关于我",
    about_sub: "资深工程师，企业级匠心。",
    about_summary: "注重结果的全栈 Java 开发工程师，拥有 8 年以上在电信、医疗、物联网、人工智能、区块链和云环境中设计、开发和现代化企业级软件的经验。在遗留系统现代化、构建可扩展的云原生应用、自动化部署以及在敏捷环境中交付可靠软件方面经验丰富。",
    about_loc: "美国公民 · 可搬迁及远程办公",
    about_certline: "持有 Cisco、Microsoft 和 CompTIA 认证 — 网络、云与安全背景",
    about_langline: "精通韩语和英语 — 在首尔企业市场交付项目 7 年",
    stat_years: "年经验", stat_projects: "企业级项目",
    stat_companies: "任职公司", stat_industries: "行业领域",
    skills_title: "技能矩阵",
    skills_sub: "全栈深度，基础设施广度。",
    skill_cat_0: "后端", skill_cat_1: "前端", skill_cat_2: "数据库",
    skill_cat_3: "DevOps 与云", skill_cat_4: "数据工程", skill_cat_5: "基础设施",
    exp_title: "工作经历",
    exp_sub: "在首尔要求最严苛的工程组织中积累了 7 年企业级交付经验。",
    type_contract: "合同制", type_fixedterm: "定期自由职业", type_startup: "创业公司合同",
    projects_title: "精选项目",
    projects_sub: "涵盖国家医疗、电信、区块链、银行、智慧城市和应用 AI 领域的 15 个生产系统。点击任意项目查看完整介绍。",
    case_study: "案例研究",
    live_site: "在线网站",
    read_case: "查看完整案例",
    visit_live: "访问网站",
    tech_stack: "技术栈",
    edu_title: "教育与证书",
    edu_sub: "点击任意证书查看官方证书或成绩单。",
    earned: "获得", expired: "已过期",
    status_active: "有效", status_inactive: "已停用", status_expired: "已过期",
    open_full: "全屏查看",
    contact_title: "让我们携手共创",
    contact_sub: "正在招聘高级后端或全栈职位？直接联系我 — 点击我的邮箱打开您的邮件应用，或一键复制我的任何联系方式。",
    email_hint: "打开您的邮件应用",
    copy_hint: "点击复制",
    copied: "已复制到剪贴板",
    footer_role: "全栈 Java 开发工程师",
    detail_challenge: "挑战", detail_approach: "方法", detail_outcome: "成果",
    detail_all: "所有项目", detail_notfound: "未找到项目。",
    detail_back: "返回作品集", prev: "上一个", next: "下一个",
  },
};
